import React from 'react';
const TVIcon = () => (
    <svg width="37" height="32" viewBox="0 0 109 94" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="1.5"
            y="20"
            width="106"
            height="67"
            rx="5"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <rect
            x="7.5"
            y="26"
            width="94"
            height="51"
            rx="5"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <rect
            x="31"
            y="87"
            width="47"
            height="6"
            rx="1"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <path
            d="M42 9.14286L53.6364 20L74 1"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="59"
            y="81"
            width="2"
            height="10"
            rx="1"
            transform="rotate(90 59 81)"
            fill="#32AE57"
        />
    </svg>
);

export default TVIcon;
